function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled from "styled-components";
import { SIZE_OPTIONS } from "../../InputField/consts";
import PlusCircle from "../../icons/PlusCircle";
import MinusCircle from "../../icons/MinusCircle";
import ButtonLink from "../../ButtonLink";
import InputField, { Input, Prefix } from "../../InputField";
import defaultTheme from "../../defaultTheme";
import getSpacingToken from "../../common/getSpacingToken";
var PrefixSuffix = styled(function (_ref) {
  var type = _ref.type,
      props = _objectWithoutProperties(_ref, ["type"]);

  return React.createElement("div", props);
}).withConfig({
  displayName: "InputStepperStateless__PrefixSuffix",
  componentId: "ymyi85-0"
})(["flex-shrink:0;z-index:3;cursor:", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "not-allowed";
});
PrefixSuffix.defaultProps = {
  theme: defaultTheme
};
var StyledInputStepper = styled.div.withConfig({
  displayName: "InputStepperStateless__StyledInputStepper",
  componentId: "ymyi85-1"
})(["width:100%;margin-bottom:", ";", "{text-align:center;}", "{padding:0;pointer-events:auto;}"], getSpacingToken, Input, Prefix);
StyledInputStepper.defaultProps = {
  theme: defaultTheme
};
var StyledButtonWrapper = styled.div.withConfig({
  displayName: "InputStepperStateless__StyledButtonWrapper",
  componentId: "ymyi85-2"
})(["&:focus{outline:none;box-shadow:0 0 1px 1px ", ",0 0 1px 3px rgba(1,118,210,0.6);}&:focus:active{box-shadow:none;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.colorTextButtonWhiteBordered;
});
StyledButtonWrapper.defaultProps = {
  theme: defaultTheme
};

var InputStepperStateless = function InputStepperStateless(_ref4) {
  var label = _ref4.label,
      error = _ref4.error,
      onBlur = _ref4.onBlur,
      onFocus = _ref4.onFocus,
      onChange = _ref4.onChange,
      onKeyDown = _ref4.onKeyDown,
      help = _ref4.help,
      disabled = _ref4.disabled,
      name = _ref4.name,
      dataTest = _ref4.dataTest,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? SIZE_OPTIONS.NORMAL : _ref4$size,
      maxValue = _ref4.maxValue,
      minValue = _ref4.minValue,
      required = _ref4.required,
      tabIndex = _ref4.tabIndex,
      forwardedRef = _ref4.forwardedRef,
      spaceAfter = _ref4.spaceAfter,
      value = _ref4.value,
      onDecrement = _ref4.onDecrement,
      onIncrement = _ref4.onIncrement,
      disabledIncrement = _ref4.disabledIncrement,
      disabledDecrement = _ref4.disabledDecrement,
      titleIncrement = _ref4.titleIncrement,
      titleDecrement = _ref4.titleDecrement;
  return React.createElement(StyledInputStepper, {
    spaceAfter: spaceAfter
  }, React.createElement(InputField, {
    dataTest: dataTest,
    size: size,
    label: label,
    disabled: disabled,
    required: required,
    name: name,
    error: error,
    help: help,
    type: typeof value === "number" ? "number" : "text",
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    value: value,
    minValue: minValue,
    maxValue: maxValue,
    tabIndex: tabIndex,
    ref: forwardedRef,
    prefix: React.createElement(StyledButtonWrapper, {
      role: "button",
      tabIndex: "0",
      onKeyDown: onDecrement
    }, React.createElement(ButtonLink, {
      disabled: disabledDecrement || disabled || typeof value === "number" && value <= +minValue,
      iconLeft: React.createElement(MinusCircle, {
        color: "secondary"
      }),
      size: size,
      onClick: onDecrement,
      transparent: true,
      component: PrefixSuffix,
      title: titleDecrement
    })),
    suffix: React.createElement(StyledButtonWrapper, {
      role: "button",
      tabIndex: "0",
      onKeyDown: onIncrement
    }, React.createElement(ButtonLink, {
      disabled: disabledIncrement || disabled || typeof value === "number" && value >= +maxValue,
      iconLeft: React.createElement(PlusCircle, {
        color: "secondary"
      }),
      size: size,
      onClick: onIncrement,
      transparent: true,
      component: PrefixSuffix,
      title: titleIncrement
    }))
  }));
};

export default InputStepperStateless;